import React, { useState, useEffect } from 'react';  
import Header from "../Component/Header";
import { useNavigate, Link } from "react-router-dom";
import { getNewsInner } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
const News = () => {
  useEffect(() => {
    document.title = 'Circulars - The Air Force School Subroto Park ';  
}, []);  
    const navigate = useNavigate();  
    const [filterData, setFilteredData] = useState([]);  
    const [openModel, setOpenmodal] = useState(false); 
    const [selectedItem, setSelectedItem] = useState(null); 
    const [data, setData] = useState([]); 
    const [selectedYear, setSelectedYear] = useState();
    const [selectedMonth, setSelectedMonth] = useState("All");
    const [monthOptions, setMonthOptions] = useState(["All"]);
    const [yearRanges, setYearRanges] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [archivedData, setArchivedData] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
  
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  
   // Get current year for default selection
   useEffect(() => {
    const currentYear = new Date().getFullYear();
    setSelectedYear(`${currentYear}`);
  }, []);

  // Fetch data and set the gallery data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData1 = await getNewsInner();
         const galleryData =  galleryData1.filter((item) =>  item.category ==="News" )
         console.log("news",galleryData)
         setData(galleryData);

        // Get unique years and months for filtering
        const yearsSet = new Set();
        const monthsSet = new Set();

        galleryData.forEach(item => {
          if (item.fromDate) {
            const date = new Date(item.fromDate); 
            yearsSet.add(date.getFullYear());
            monthsSet.add(date.getMonth());
          }
        });

        const uniqueYearRanges = Array.from(yearsSet).sort((a, b) => b - a);
        setYearRanges(uniqueYearRanges);

        const monthOptions = Array.from(monthsSet).sort((a, b) => a - b).map(month => monthNames[month]);
        setMonthOptions(["All", ...monthOptions]);

        setLoading(false); // Data has been fetched, update loading state
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = data;
  
    // Separate archived and valid data
    const archived = filteredData.filter(item => !item.fromDate); // Archived items (no date)
    const validData = filteredData.filter(item => item.fromDate); // Valid items (with date)
  
    if (selectedYear === "All" && selectedMonth === "All" && searchQuery === "") {
      setFilteredData(validData);
      setArchivedData(archived); // Show archived data when no filters are applied
      return;
    }
  
    // If "Archive" is selected, show only archived data
    if (selectedYear === "Archive") {
      setFilteredData([]);
      setArchivedData(archived);
      return;
    } 
  
    // Get current month and year
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // 0-based index (Jan = 0)
  
    // Separate current month data
    const currentMonthData = validData.filter(item => {
      const itemDate = item.fromDate?.trim();
      if (itemDate) {
        const date = new Date(itemDate);
        const itemYear = date.getFullYear();
        const itemMonth = date.getMonth();
        return itemYear === currentYear && itemMonth === currentMonth;
      }
      return false;
    });
  
    // Filter the rest of the data (not in current month)
    const restOfTheData = validData.filter(item => {
      const itemDate = item.fromDate?.trim();
      if (itemDate) {
        const date = new Date(itemDate);
        const itemYear = date.getFullYear();
        const itemMonth = date.getMonth();
        return itemYear !== currentYear || itemMonth !== currentMonth;
      }
      return false;
    });
  
    // Sort the rest of the data in ascending order
    restOfTheData.sort((a, b) => new Date(a.fromDate) - new Date(b.fromDate));
  
    // Combine current month data and the rest
    const combinedData = [...currentMonthData, ...restOfTheData];
  
    // Apply filtering based on year, month, and search query
    if (selectedYear !== "All") {
      const year = parseInt(selectedYear);
      filteredData = combinedData.filter(item => {
        const itemDate = item.fromDate?.trim();
        if (itemDate) {
          const date = new Date(itemDate);
          const itemYear = date.getFullYear();
          const itemMonth = date.getMonth();
          return itemYear === year && (selectedMonth === "All" || monthNames[itemMonth] === selectedMonth);
        }
        return false;
      });
    }
  
    // If a month is selected but no year, filter by month
    if (selectedMonth !== "All" && selectedYear === "All") {
      filteredData = combinedData.filter(item => {
        const itemDate = item.fromDate?.trim();
        if (itemDate) {
          const itemMonth = new Date(itemDate).getMonth();
          return monthNames[itemMonth] === selectedMonth;
        }
        return false;
      });
    }
  
    // Search filtering
    if (searchQuery) {
      filteredData = filteredData.filter(item => {
        return item.title && item.title.toLowerCase().includes(searchQuery.toLowerCase());
      });
    }
    filteredData.sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));
    // Set filtered data
    setFilteredData(filteredData);
    setArchivedData(archived); // Set archived data separately
  }, [selectedYear, selectedMonth, searchQuery, data]);

  const handleModal = id => {
    navigate(`/SubGallery?id=${id}`);
  };
  
    const modalPopup = (item) => {
      setSelectedItem(item); // Set the clicked item's data
      setOpenmodal(true); // Open the modal
  };
  
  const handleClose = () => {
      setOpenmodal(false);
      setSelectedItem(null); // Clear the selected item
  };
    const emptyArray = [
       {id:1},
       {id:2},
       {id:3},
    ];
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    };
    
  return (
     <>
    
       <Header/>
<div className="innerslide">
     <ul className="breadcrumb">
         <li><Link to="/"> Home</Link> </li> 
             
          <li>Circulars</li>
     </ul>
 </div> 
 <div className="innersec">
     <div className="container">
         <div className="row">
             <div className="col-lg-12">
                 <h1>Circulars</h1>
             </div>
         </div>
             <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="count-val">
                <p>Total Categories: {filterData.length}</p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  <option value="All">All</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>{yr}</option>
                  ))}
                   
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="monthSelect"
                >
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>{month}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>    
          {loading ? (
            <div><img src="https://webapi.entab.info/api/image/TAFS/public/Images/loading.gif" className="img-fluid loadingimg"/></div>
     ) : (
             filterData.length > 0 && (
              <div className="row years year2024 showYear">
                {filterData.map((item, index) => {
                  const date = new Date(item.fromDate);
                  const day = date.getDate();
                  const month = monthNames[date.getMonth()];
                  return (
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount" key={index}>
                   
                    <div className="eventsnewsbox">
                    <div className="newsboximg">
                     {item.image.length > 0 ? (
                            <LazyLoad>
                                <img src={`https://webapi.entab.info/api/image/${item?.image[0]}`} className="img-fluid" alt="TAFS" />
                            </LazyLoad>
                        ) : (
                            <LazyLoad>
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/Circulars.jpg" className="img-fluid defaultimg" alt="TAFS" />
                            </LazyLoad>
                        )}
                        </div>
                        <div className="newsboxdesc">
                           <div className="newspgh">  
                           <h5>{item.title}</h5> 
                            <p><small>  <i className="bi bi-calendar"></i> {formatDate(item.fromDate)} </small></p> 
                            <button onClick={() => modalPopup(item)} className="readmorebtn">Read More</button>
                            
                       </div> 
                        
                </div>
                </div>
                    </div>
                  );
                })}
              </div>
              )
            )} 
            </div> 
</div> 
{openModel && selectedItem && (
  <div className="eventPopup">
    <div className="eventpopupbody">
      <div className="eventpopupcontent">
        <button onClick={handleClose} className="closebtn">X</button>
        <div className="schooleventbox">
        <div className="schooleventrightbox">
        <h5><div dangerouslySetInnerHTML={{ __html: selectedItem.title }} /> </h5>
            <p> <div dangerouslySetInnerHTML={{ __html: selectedItem.description }} /></p>
            {selectedItem.attachments && selectedItem.attachments[0] && ( 
              <div className="attachment popupattch">
              <Link to={`https://webapi.entab.info/api/image/${selectedItem?.attachments}`} target="_blank"> Click Here To View</Link>
          </div>
            )} 
        </div>
        {selectedItem.image && selectedItem.image.length > 0 ? (
          selectedItem.image.map((image, index) => (
            <div key={index} className="schooleventleftbox galleryCount sub-gallerycount subnews">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src={`https://webapi.entab.info/api/image/${image}`} // Using image source for gallery
                  data-group="a"
                  href={`https://webapi.entab.info/api/image/${image}`}
                >
                  <img
                    src={`https://webapi.entab.info/api/image/${image}`}
                    className="img-fluid float-start"
                    alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                  />
                </a>
              </LazyLoad>
            </div>
          ))
        ) : null}  
        </div>
        
         <div className="row">
         {selectedItem.galleryAttachments?.length > 0 && (
              selectedItem.galleryAttachments.map((item,index) => (
                <div
                key={index}
                className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"
              >
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${item}`}><img src={`https://webapi.entab.info/api/image/${item}`} className=" img-fluid" alt="The Air Force School Subroto Park" /></a>
                  </LazyLoad>
              </div> 
              ))
    )}
         </div>
      </div>
    </div>
  </div>
)}
    </>
  )
}

export default News
